/* jshint ignore:start */
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        //The FAQ page
        $(".faq-main-container .faq-item .question").click(function () {
          var parentDiv = $(this).parent(".faq-item");
          if ($(this).hasClass("active")) {
            parentDiv.find(".question").removeClass("active");
            parentDiv.find(".answer").slideUp(300);
          } else {
            parentDiv.find(".question").addClass("active");
            parentDiv.find(".answer").slideDown(300);
          }
        });

        $(".popup-youtube").magnificPopup({
          type: "iframe",
        });

        $(".js-embed-video-handler").click(function (e) {
          e.preventDefault();
          var link = $(".js-embed-video").attr("data-link");
          $(".home-content-block-full .title").fadeOut();
          $(".js-embed-video").html(
            "<video width='100%' height='auto' loop autoplay controls><source src='" +
              link +
              "' type='video/mp4'></video>"
          );
        });

        //Code to operate the mobile navigation menu
        $(".mobile-navigation-button").click(function () {
          $(".mobile-navigation-overlay").slideDown(300);
        });

        $(".mobile-navigation-overlay .close-icon").click(function () {
          $(".mobile-navigation-overlay").slideUp(300);
        });

        //I the testimonial section exists, we want it to be a slider
        if ($(".testimonial-section").length > 0) {
          $(".owl-carousel").owlCarousel({
            margin: 10,
            loop: true,
            items: 1,
            autoplay: true,
            autoHeight: true,
            autoplayTimeout: 9000,
            // autoplaySpeed: 2000
          });
        }

        //int dist page
        $(".select-a-location-block .value").click(function () {
          $(".please-select-location").slideUp(300);
          //Hide the options container
          if (
            $(".select-a-location-block .option-container").hasClass("active")
          ) {
            $(".select-a-location-block .option-container")
              .slideUp(300)
              .removeClass("active");
          } else {
            $(".select-a-location-block .option-container")
              .slideDown(300)
              .addClass("active");
          }
        });

        //If one of the options is clicked
        $(".select-a-location-block .option").click(function () {
          var countryString = "." + $(this).attr("id");
          countryString = countryString.replace(/\s+/g, "-").toLowerCase();
          // console.log(countryString);

          $(".select-a-location-block .value").text($(this).attr("ID"));

          $(".select-a-location-block .option-container")
            .slideUp(300)
            .removeClass("active");

          $(".dist-company").fadeOut(200);
          $(".company-contact-block-container")
            .find(countryString)
            .delay(400)
            .slideDown(300);
        });

        if (!Cookies.get("firstvisit")) {
          Cookies.set("firstvisit", 1, { expires: 1 });
          $("#trigger").fancybox().trigger("click");
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    //Testimonial page
    testimonials: {
      init: function () {
        var homeVideo = $("video");
        homeVideo.click(function () {
          this.paused ? this.play() : this.pause();

          if (
            $(".testimonial-page-video-container .overlay-image").is(":visible")
          ) {
            $(".testimonial-page-video-container .overlay-image").fadeOut(100);
          } else {
            $(".testimonial-page-video-container .overlay-image").fadeIn(100);
          }
        });
      },
    },

    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page

        var homeVideo = $(".home-video-block-container video");
        homeVideo.click(function () {
          this.paused ? this.play() : this.pause();

          if ($(".home-video-block-container .overlay-image").is(":visible")) {
            $(".home-video-block-container .overlay-image").fadeOut(100);
          } else {
            $(".home-video-block-container .overlay-image").fadeIn(100);
          }
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    // Single Product Page
    single_product: {
      init: function () {
        /**
         * @license lyradesigns.com v1
         * Updated: Dec 17, 2014
         * Add pin buttons to images
         * Copyright (c) 2014 Jonas Goslow - LYRA
         * Released under the MIT license
         * https://github.com/timmywil/jquery.panzoom/blob/master/MIT-License.txt
         */
        $.fn.imgPin = function (options) {
          // Extend our default options with those provided.
          // Note that the first argument to extend is an empty
          // object – this is to keep from overriding our "defaults" object.
          var defaults = {
            pinImg:
              "https://assets.pinterest.com/images/pidgets/pin_it_button.png",
            position: 1, // Display default header
          };
          var options = $.extend({}, defaults, options);

          var url = encodeURIComponent(document.URL),
            pinImg = options.pinImg,
            position = "";

          switch (options.position) {
            case 1:
              position = "top left";
              break;
            case 2:
              position = "top right";
              break;
            case 3:
              position = "bottom right";
              break;
            case 4:
              position = "bottom left";
              break;
            case 5:
              position = "center";
              break;
          }

          this.each(function () {
            // add Pin buttons to all images
            var src = $(this).attr("src"),
              shareURL = url;

            // get image dimensions - if < 500 then return
            var img = new Image();
            img.src = src;

            // Get Title and img to pin - encode them
            var description = encodeURIComponent(document.title),
              imgURL = encodeURIComponent(src);

            // Generate link
            var link = "https://www.pinterest.com/pin/create/button/";
            link += "?url=" + shareURL;
            link += "&media=" + imgURL;
            link += "&description=" + description;

            //add wrappers
            $(this)
              .wrap('<div class="imgPinWrap">')
              .after(
                '<a href="' +
                  link +
                  '" class="pin ' +
                  position +
                  '"><img src="' +
                  pinImg +
                  '" alt="Pin this!"></a>'
              );

            //position center
            if (options.position == 5) {
              var img = new Image();
              img.onload = function () {
                var w = this.width;
                h = this.height;
                $(".imgPinWrap .pin.center")
                  .css("margin-left", -w / 2)
                  .css("margin-top", -h / 2);
              };
              img.src = pinImg;
            }

            //set click events
            $(".imgPinWrap .pin").click(function () {
              var w = 700,
                h = 400;
              var left = screen.width / 2 - w / 2;
              var top = screen.height / 2 - h / 2;
              var imgPinWindow = window.open(
                this.href,
                "imgPngWindow",
                "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=700, height=400"
              );
              imgPinWindow.moveTo(left, top);
              return false;
            });
          });
        };

        // activate imgpin
        $(".product-featured-image").imgPin({
          pinImg: templateUrl + "/assets/images/pinit.png",
        });

        // The featured image slider
        var currentImage = 0;
        var lengthOfImages = $(".featured-image-controls-item").length;
        // Hide controls if only one image
        if (lengthOfImages == 1) {
          $(".featured-image-controls, .image-control-button").hide();
        }
        // console.log(lengthOfImages);
        //Set up featured image
        $(".featured-image-controls-item").click(function () {
          var newBackground = $(this).css("background-image");
          var matches = newBackground.replace('url("', "").replace('")', "");
          currentImage = $(this).index();
          // console.log(currentImage);
          $(".product-featured-image").attr("src", matches);
        });

        $(".image-control-button").click(function () {
          if ($(this).hasClass("prev")) {
            if (currentImage === 0) {
              currentImage = 0;
              var currentItem = $(".featured-image-controls-item")
                .eq(lengthOfImages - 1)
                .css("background-image")
                .replace('url("', "")
                .replace('")', "");
              $(".product-featured-image").attr("src", currentItem);
              currentImage = lengthOfImages - 1;
            } else {
              var currentItem = $(".featured-image-controls-item")
                .eq(currentImage - 1)
                .css("background-image")
                .replace('url("', "")
                .replace('")', "");
              $(".product-featured-image").attr("src", currentItem);
              currentImage--;
            }
          }

          if ($(this).hasClass("next")) {
            if (currentImage == lengthOfImages - 1) {
              var currentItem = $(".featured-image-controls-item")
                .eq(0)
                .css("background-image")
                .replace('url("', "")
                .replace('")', "");
              $(".product-featured-image").attr("src", currentItem);
              currentImage = 0;
            } else {
              var currentItem = $(".featured-image-controls-item")
                .eq(currentImage + 1)
                .css("background-image")
                .replace('url("', "")
                .replace('")', "");
              $(".product-featured-image").attr("src", currentItem);
              currentImage++;
            }
          }
        });

        $(".information-container .specification").fadeIn(300);

        function productInformationSlide(buttonToAddClassTo, itemToFadeIn) {
          $(".information-container").fadeOut(300, function () {
            $(".single-product-buttons .active").removeClass("active");
            buttonToAddClassTo.addClass("active");
          });
          itemToFadeIn.delay(350).fadeIn(300);
        }

        //The jquery for the buttons
        $(".single-product-buttons #specification").click(function () {
          productInformationSlide(
            $(".single-product-buttons #specification"),
            $(".information-container.specification")
          );
        });
        $(".single-product-buttons #faq").click(function () {
          productInformationSlide(
            $(".single-product-buttons #faq"),
            $(".information-container.faq")
          );
        });
        $(".single-product-buttons #review").click(function () {
          productInformationSlide(
            $(".single-product-buttons #review"),
            $(".information-container.review")
          );
        });
      },
    },

    //If a videos post
    single_videos: {
      init: function () {
        $("#menu-item-31 a").addClass("active");
      },
    },

    //Contact Us
    contact_us: {
      init: function () {
        //Contact form Country dropown
        $(".custom-select .value").click(function () {
          $(".custom-select .options").slideDown(300);
        });

        $(".custom-select .options .option").click(function () {
          var theValue = $(this).text();
          $("#country").val(theValue);
          $(".custom-select .value").text(theValue);
          $(".custom-select .options").slideUp(300);
        });

        //Contact Form Ajax
        var contactForm = $("#contactForm");
        $(contactForm).submit(function (event) {
          // Stop the browser from submitting the form.
          event.preventDefault();

          var formData = $(contactForm).serialize();

          var formNotValid = true;

          if ($("#name").val() === "" || $("#name").val() === " ") {
            $("#name").addClass("error");
            formNotValid = true;
          } else {
            $("#name").removeClass("error");
            formNotValid = false;
          }

          if (
            $("#phone_number").val() === "" ||
            $("#phone_number").val() === " "
          ) {
            $("#phone_number").addClass("error");
            formNotValid = true;
          } else {
            $("#phone_number").removeClass("error");
            formNotValid = false;
          }

          if ($("#email").val() === "" || $("#email").val() === " ") {
            $("#email").addClass("error");
            formNotValid = true;
          } else {
            $("#email").removeClass("error");
            formNotValid = false;
          }

          if ($("#message").val() === "" || $("#message").val() === " ") {
            $("#message").addClass("error");
            formNotValid = true;
          } else {
            $("#message").removeClass("error");
            formNotValid = false;
          }

          if (formNotValid === false) {
            // Submit the form using AJAX.
            $.ajax({
              type: "POST",
              url: $(contactForm).attr("action"),
              data: formData,
            })
              .done(function (response) {
                // Set the message text.

                $("#contactForm").fadeOut(300, function () {
                  $(".contact-form-thanks").fadeIn(300);
                });
              })
              .fail(function (data) {
                // Set the message text.
                if (data.responseText !== "") {
                  console.log(data.responseText);
                } else {
                  console.log(
                    "Oops! An error occured and your message could not be sent."
                  );
                }
              });
          } else {
            $(".please-enter-required").slideDown(300);
          }
        });
      },
    },

    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page

        //Show all of the timeline blocks when the button is clicked
        $(".timeline-content-block .button").click(function () {
          $(".timeline-content-block .button").fadeOut(300, function () {
            $(".not-shown").slideDown(300);
          });
        });
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // detect mouse on homepage iframe and hide the title
  $(".home-video-block-container iframe").on("mouseenter", function () {
    // console.log('iframe mouseover');
    $(".home-video-block-container .title-boxed").hide();
  });

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      jQuery(function ($) {
        $(".newsletter-form").hide();

        $(".newsletter-success").show();
      });
    },
    false
  );
})(jQuery); // Fully reference jQuery after this point.
/* jshint ignore:end */
